import { Component } from '@angular/core';
import { DynamicDialogComponent, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-agenda-modal',
  templateUrl: './agenda-modal.component.html',
  styleUrls: ['./agenda-modal.component.scss']
})
export class AgendaModalComponent {

  selected = 'consulta';
  constructor(public config: DynamicDialogComponent) {

  }

  closeModal() {
    this.config.close();
  }
  cancelar() {
    this.closeModal();
  }
  salvar() {
    this.closeModal();
  }
  onOptionClick(option : any) {

  }
}
